<div class="new-content">
  <hyperkit-typography variant="h1" color="primary" align="center"
    >Create New Password</hyperkit-typography
  >
  <hyperkit-typography variant="body" size="sm" color="secondary"
    >{{ passRequirements }}
  </hyperkit-typography>
  @if (!formSubmitted) {
    <form [formGroup]="newPasswordForm" (ngSubmit)="onUpdatePassword()">
      <div class="form-group">
        <hyperkit-input
          class="hyperkit-component"
          type="password"
          id="password"
          label="New Password"
          placeholder="New Password"
          formControlName="password"
          [pattern]="passRegex"
        ></hyperkit-input>
      </div>
      <div class="form-group">
        <hyperkit-input
          class="hyperkit-component"
          type="password"
          label="Confirm Password"
          placeholder="Confirm Password"
          formControlName="confirmPassword"
        ></hyperkit-input>
        @if (
          newPasswordForm.controls.confirmPassword.touched &&
          newPasswordForm.controls.confirmPassword.dirty &&
          newPasswordForm.controls.password.value !==
            newPasswordForm.controls.confirmPassword.value &&
          newPasswordForm.controls.confirmPassword.value.length > 0
        ) {
          <hyperkit-error
            class="form-error"
            [error]="'Passwords do not match.'"
          ></hyperkit-error>
        }
      </div>
      <div class="options">
        <hyperkit-button
          type="submit"
          class="sign-in-button"
          size="medium"
          [disabled]="!newPasswordForm.valid"
          [fullWidth]="true"
          color="tertiary"
          text="Change Password"
        ></hyperkit-button>
      </div>
    </form>
  }
  @if (formSubmitted) {
    <hyperkit-typography variant="body" size="md" color="primary"
      >Your password has been updated successfully.
    </hyperkit-typography>
    <hyperkit-button
      class="sign-in-button"
      routerLink="/"
      size="medium"
      [fullWidth]="true"
      color="tertiary"
      text="Return to Login"
    ></hyperkit-button>
  }
</div>
